@if (model()) {
  <form [formGroup]="formGroup" class="row gap-md-0 gap-4">
    <div class="col-12 col-md-6">
      <div class="row gap-4">
        <!-- BANK ACCOUNTS (read-only, aus Odoo synchronisiert) -->
        <div class="col-sm-12"><h5 class="m-0">{{ 'CUSTOMERS.BANK_ACCOUNTS' | translate }}</h5></div>
        <div class="col-sm-12">
          @if ((model()!.erpBankAccounts ?? []).length > 0) {
            <ul class="list-group">
              @for (bank of model()!.erpBankAccounts; track bank.id) {
                <li class="list-group-item d-flex justify-content-between">
                  <span>{{ bank.accNumber }}</span>
                  @if (bank.bank) {
                    <span class="text-muted">{{ bank.bank }}</span>
                  }
                </li>
              }
            </ul>
            <small class="text-muted">{{ 'CUSTOMERS.BANK_ACCOUNTS_SYNC_HINT' | translate }}</small>
          } @else {
            <span class="text-muted">{{ 'CUSTOMERS.NO_BANK_ACCOUNTS' | translate }}</span>
          }
        </div>
        <!-- LEI -->
        <div class="col-sm-12">
          <app-form-input [controlName]="'iso20022Lei'"
                          [formGroup]="formGroup"
                          [id]="'iso20022Lei'"
                          [label]="'CUSTOMERS.LEI'"></app-form-input>
        </div>
        <!-- AUTOPOST BILLS -->
        <div class="col-sm-12">
          <app-enum-select [controlName]="'autopostBills'"
                           [formGroup]="formGroup"
                           [enum]="autopostBillsEnum"
                           [label]="'CUSTOMERS.AUTOPOST_BILLS'"
                           [castFunction]="castAutopostBills"></app-enum-select>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="row gap-4">
        <div class="col-sm-12"><h5 class="m-0">{{ 'CUSTOMERS.INVOICE_CHECKS' | translate }}</h5></div>
        <!-- IGNORE ABNORMAL AMOUNT / DATE -->
        <div class="col-sm-12">
          <app-checkbox-input [controlName]="'ignoreAbnormalInvoiceAmount'"
                              [formGroup]="formGroup"
                              [id]="'ignoreAbnormalInvoiceAmount'"
                              [label]="('CUSTOMERS.IGNORE_ABNORMAL_AMOUNT'|translate)"></app-checkbox-input>
        </div>
        <div class="col-sm-12">
          <app-checkbox-input [controlName]="'ignoreAbnormalInvoiceDate'"
                              [formGroup]="formGroup"
                              [id]="'ignoreAbnormalInvoiceDate'"
                              [label]="('CUSTOMERS.IGNORE_ABNORMAL_DATE'|translate)"></app-checkbox-input>
        </div>
        <!-- CREDIT LIMIT -->
        <div class="col-sm-12">
          <app-checkbox-input [controlName]="'usePartnerCreditLimit'"
                              [formGroup]="formGroup"
                              [id]="'usePartnerCreditLimit'"
                              [label]="('CUSTOMERS.USE_CREDIT_LIMIT'|translate)"></app-checkbox-input>
        </div>
        @if (formGroup.get('usePartnerCreditLimit')?.value) {
          <div class="col-sm-12">
            <app-form-input [controlName]="'creditLimit'"
                            [formGroup]="formGroup"
                            [id]="'creditLimit'"
                            [label]="'CUSTOMERS.CREDIT_LIMIT'"
                            [type]="'number'"
                            [min]="0"
                            [allowDecimalNumbers]="true"></app-form-input>
          </div>
        }
      </div>
    </div>
  </form>
  <div class="d-flex justify-content-end align-items-center mt-4">
    <app-mdb-button (onClick)="submit()" [loading]="loading" [text]="'SAVE'"></app-mdb-button>
  </div>
} @else {
  <app-spinner></app-spinner>
}
